// extracted by mini-css-extract-plugin
export default {"container":"styles_container__3FJeY","innerContainer":"styles_innerContainer__oWdUW","logo":"styles_logo__6kHwY"};